import { ApiError, apiPost } from './client'

// POST /pro/play/link-token (wire contract: play-billing-contract.md).
//
// Mints a short-lived, single-use token that the Android app's native Play
// paywall resolves to the signed-in account. The body carries the SHA-256 of
// the device key (src/lib/deviceKey.ts), never the key: the server binds the
// token to that hash, and only the app holding the key itself can resolve it.
//
//   200 {"token": "<URL-safe, <=512 chars>", "expires_at": <unix seconds>}
//   401 no/invalid auth; 403 {"detail":"email_required"} for an anonymous or
//   email-less account; 422 bad hash; 503 the server is not set up for it.

export interface PlayLinkToken {
  token: string
  /** Unix seconds. */
  expires_at: number
}

export const EMAIL_REQUIRED_DETAIL = 'email_required'

export function fetchPlayLinkToken(
  bearerToken: string,
  deviceKeyHash: string,
  signal?: AbortSignal,
): Promise<PlayLinkToken> {
  return apiPost<PlayLinkToken>('/pro/play/link-token', { device_key_hash: deviceKeyHash }, { bearerToken, signal })
}

/** The 403 the server sends for an account it will not sell to (guest or email-less). */
export function isEmailRequired(err: unknown): boolean {
  return err instanceof ApiError && err.status === 403 && err.detail === EMAIL_REQUIRED_DETAIL
}
